export default __webpack_public_path__ + "static/media/multi-check.82820f1c.svg";